/**
 * Module-scoped scroll-position store.
 *
 * Mirrors the `comparisonCache.js` idiom: the store lives for the app's
 * lifetime, surviving React route unmount/remount, so a page can restore
 * its scroll offsets when the user navigates away and back. Cleared on a
 * full page reload (module re-evaluation), which is the desired scope —
 * scroll retention is a within-session convenience, not persisted state.
 */
const _positions = new Map();

/**
 * Return the saved scroll position for a key, or null.
 *
 * @param {string} key  Page/container identifier (e.g. 'comparison').
 * @returns {{top: number, left: number}|null}
 */
export function getScrollPosition(key) {
  return _positions.get(key) ?? null;
}

/**
 * Save a scroll position under a key.
 *
 * @param {string} key                      Page/container identifier.
 * @param {{top: number, left: number}} pos Scroll offsets in pixels.
 */
export function saveScrollPosition(key, pos) {
  _positions.set(key, pos);
}

/** Drop the saved position for a key (e.g. after a data refresh). */
export function clearScrollPosition(key) {
  _positions.delete(key);
}
